export enum AgentDealStatus {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive',
  UPCOMING = 'Upcoming',
  UNKNOWN = '-',
}
